import React from "react";
import { Colors } from "../palettes/colorPalette";
import { backgroundTexture } from "../uiConstants";
import { GameClient } from "../gameClient";
import { UIButtonSmall } from "../styles/ButtonStyle";
import { ClientReconnectingState } from "../states/clientReconnectingState";

declare var gameClient: GameClient;

/** Shown to a player who has lost the game server, while we try to get it back and once we have
    given up. The reconnecting state owns the attempts; this only reports them. */
export const ClientDisconnectedBanner = () => {
	const state = gameClient.stateSystem?.peekState();
	const reconnecting = state instanceof ClientReconnectingState ? state : null;

	return (
		//Deliberately not a modal: the player has to be able to reach the menu and back out of a
		//game that isn't coming back, so only the panel itself takes clicks
		<div style={{
			position: 'absolute',
			top: 0, left: 0,
			width: '100%', height: '100%',
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			zIndex: 20,
			pointerEvents: 'none',
		}}>
			<div style={{
				background: `url(${backgroundTexture})`,
				backgroundColor: Colors.UIBackground,
				padding: '1.5vw 2vw',
				filter: `drop-shadow(2px 4px 2px ${Colors.UITextAndBorders})`,
				fontSize: '2vw',
				color: Colors.UITextAndBorders,
				textAlign: 'center',
				pointerEvents: 'auto',
			}}>
				{reconnecting?.failed ?
					<>
						<div>Reconnect failed, make sure host is reachable</div>
						<UIButtonSmall
							style={{ marginTop: '1vw', fontSize: '0.5em' }}
							onClick={() => reconnecting.retry()}
						>
							Try Again
						</UIButtonSmall>
					</> :
					'Reconnecting...'
				}
			</div>
		</div>
	);
};
